import Image from "next/image";
import {Link} from "@/i18n/routing";
import defaultPhoto from '@/assets/img/user/default.png';
import {formatBlogDate} from '@/libs/date.util';
import {useTranslations} from 'next-intl';


export default function BlogCardPrimary({ blog }) {
  const t = useTranslations('blog');
  const d = useTranslations('date.months');
  
  return (
      <div className="ltn__blog-item ltn__blog-item-3">
        <div className="ltn__blog-img">
          <Link href={`/blog/${blog.alt}`}>
            <Image
                src={blog.coverImage}
                alt={`blog-${blog.title}`}
                placeholder="blur"
                blurDataURL={blog.coverImage}
                width={800}
                height={562}
                loading="lazy"
                style={{height: 'auto', aspectRatio: 800/562, objectFit: 'cover'}}
            />
          </Link>
        </div>
        <div className="ltn__blog-brief">
          <h3 className="ltn__blog-title">
            <Link href={`/blog/${blog.alt}`}>{blog.title}</Link>
          </h3>
          <p className="ltn__blog-thesis no-wrap-text-2">
            {blog.thesis}
          </p>
          <div className="ltn-blog-read">
            <i className="far fa-clock"></i>{blog.timeToRead > 0 ? `${blog.timeToRead}` : '<1'} {t('minRead')}
          </div>
          <div className="ltn__blog-meta-btn">
            <div className="ltn__blog-meta">
              <ul>
                <li className="ltn__blog-author">
                  <Image
                      src={blog.user.image ?? defaultPhoto}
                      alt={`user-${blog.user.shortFullName}`}
                      placeholder="blur"
                      blurDataURL={blog.user.image}
                      width={45}
                      height={45}
                      loading="lazy"
                      style={{height: 'fit-content', aspectRatio: 1, objectFit: 'cover'}}
                  />
                  <div className="ltn-blog-author-desc">
                    <div className="ltn-blog-author-name">{blog.user.shortFullName}</div>
                    <div className="ltn-blog-read">
                      <i className="far fa-calendar-alt"></i>{formatBlogDate(blog.createdAt, d)}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
  );
};
